import * as Yup from 'yup';

export const ThresholdSchema = Yup.object().shape({
    threshold: Yup.string().min(1, 'Threshold is required').required('Threshold is required'),
});

export type ThresholdDataType = Yup.InferType<typeof ThresholdSchema>;

type InitialValues = {
    threshold: string;
};

export const ThresholdInitialValues: InitialValues = {
    threshold: '',
};

export interface ThresholdInterface {
    threshold: string;
}
